(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/constants.js');

const routes = {
  START: '/',
  DIGITAL_TICKETS: '/digitala-lotter',
  DIGITAL_TICKETS_RECEIPT: '/digitala-lotter/bestallning-skickad',
  PHYSICAL_TICKETS: '/fysiska-lotter',
  PHYSICAL_TICKETS_RECEIPT: '/fysiska-lotter/bestallning-skickad',
  LOGIN: '/logga-in',
  MY_ORDERS: '/mina-bestallningar',
  PASSWORD_RECOVERY: '/aterstall-losenord',
  CHANGE_PASSWORD: '/byt-losenord',
  COMPANY_DETAILS: '/foretagsuppgifter'
};

const menuItems = [{
  url: routes.START,
  displayName: 'Start'
}, {
  url: routes.DIGITAL_TICKETS,
  subUrls: [routes.DIGITAL_TICKETS_RECEIPT],
  displayName: 'Digitala lotter'
}, {
  url: routes.PHYSICAL_TICKETS,
  subUrls: [routes.PHYSICAL_TICKETS_RECEIPT],
  displayName: 'Fysiska lotter'
}, {
  url: routes.MY_ORDERS,
  displayName: 'Mina beställningar'
}, {
  url: routes.COMPANY_DETAILS,
  displayName: 'Företagsuppgifter'
}];

const copy = {
  TICKETS_TABLE: {
    PRICE: 'Pris',
    COUNT: 'Antal',
    NAME: 'Namn',
    TOTAL: 'Total',
    SUM: {
      SUM: 'Summa',
      SEK: 'kr',
      MINIMUM_AMOUNT: 1500,
      MINIMUM_AMOUNT_ERROR_MESSAGE: 'Minibelopp för första beställningen är 1 500 kr.'
    },
    MAXUMUM_COUNT: 50000,
    MAXIMUM_COUNT_ERROR_MESSAGE: 'Max antal lotter du kan beställa är 50 000 st.',
    INFO: 'Minibelopp för första beställningen är 1 500 kr.'
  },
  FOOTER: {
    AGE_TEXT: 'Det är 18 års åldersgräns på alla lotter.',
    TERMS_AND_CONDITIONS_TEXT: 'Genom att lägga din beställning på denna sida accepterar du ',
    LINK_TEXT: 'Allmänna villkor för Lotter för företag.'
  }
};

const articles = [
  { name: 'Triss', id: '1', imgSrc: '', price: 30 },
  { name: 'DubbelTriss', id: '2', imgSrc: '', price: 60 },
  { name: 'BilTriss', id: '3', imgSrc: '', price: 30 },
  { name: 'Triss Premium', id: '4', imgSrc: '', price: 30 }
];

svs.ticket_partner.constants = {
  routes,
  articles,
  copy,
  menuItems
};


 })(window);